export enum GridName {
  ORDER = 'ORDER',
  ORDER_WIDGET = 'ORDER_WIDGET',
  DELETED_ORDER = 'DELETED_ORDER',
  SIGNOFF = 'SIGNOFF',
  TEMPLATE_MODAL = 'TEMPLATE_MODAL',
  TEMPLATE_WIDGET = 'TEMPLATE_WIDGET',
  UPLOAD = 'UPLOAD',
  FROM_TEMPLATE = 'FROM_TEMPLATE',
  CLIENT = 'CLIENT',
  USERMGMT = 'USERMGMT',
  LOG = 'LOG',
  TRANSACTIONS = 'TRANSACTIONS',
  USERGROUPS = 'USER_GROUPS',
}
